import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import POServices from "../../../services/PoServices";
import ReapirPoServices from "../../../services/RepairPoServices";
import RequestServies from '../../../services/RequestServies';
import Swal from "sweetalert2";

const POEditModal = ({ show, handleClose, item, test }) => {
  console.log("kkkk", item)
  const [formData, setFormData] = useState({ supplier: "", items: [], deliveryAddress: {} });
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch supplier list
  const fetchSuppliers = async () => {
    try {
      const res = await POServices.activeSuppliers();
      setSuppliers(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch suppliers", err);
    }
  };

  useEffect(() => {
    if (show) fetchSuppliers();
  }, [show]);

  // Initialize formData when item changes
  useEffect(() => {
    if (item) {
      setFormData(prev => ({
        ...prev,
        termCondition: item?.termCondition || [],
        supplier: item?.supplier?._id || "",
        requisitionNo: item?.repairOrder?.repairOrderNo || "",
        deliveryAddress: item?.supplier?.address || {},
        items: item.items?.map(poItem => ({
          id: poItem._id,
          partNo: poItem.repairItemId?.masterlist?.partNo || "",
          description: poItem?.description || "",
          approveQty: poItem.approveQty,       // SHOWN but NOT UPDATED
          rate: poItem.rate || 0,
          cgst: poItem.cgst || 0,
          sgst: poItem.sgst || 0,
          igst: poItem.igst || 0
        })) || []
      }));
    }
  }, [item]);



  // Handle local input changes
  const handleInputChange = (idx, field, value) => {
    const newItems = [...formData.items];

    if (field === "cgst") {
      newItems[idx].cgst = parseFloat(value) || 0;
      newItems[idx].sgst = newItems[idx].cgst;
      newItems[idx].igst = 0;

    } else if (field === "igst") {
      newItems[idx].igst = parseFloat(value) || 0;
      newItems[idx].cgst = 0;
      newItems[idx].sgst = 0;

    } else if (field === "approveQty" || field === "rate") {
      newItems[idx][field] = value === "" ? "" : Number(value);
    }

    setFormData(prev => ({ ...prev, items: newItems }));
  };

  // Calculate totals
  const calculateTotals = () => {
    let base = 0, cgst = 0, sgst = 0, igst = 0;
    formData.items.forEach(it => {
      const lineBase = (parseFloat(it.rate) || 0) * (parseFloat(it.approveQty) || 0);
      base += lineBase;
      cgst += (lineBase * (parseFloat(it.cgst) || 0)) / 100;
      sgst += (lineBase * (parseFloat(it.sgst) || 0)) / 100;
      igst += (lineBase * (parseFloat(it.igst) || 0)) / 100;
    });
    return {
      base: base.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      total: (base + cgst + sgst + igst).toFixed(2),
    };
  };

  // Submit both PO and item qty updates
  const handleSubmit = async () => {
    try {
      if (!formData.supplier) {
        Swal.fire("Error", "Please select supplier", "error");
        return;
      }

      let hasInvalid = false;

      const cleanedItems = formData.items.map((it, idx) => {
        const description = it.description?.trim();
        const rate = Number(it.rate);
        const qty = Number(it.approveQty);

        // ❗ Description validation
        if (!description) hasInvalid = true;

        // ❗ Rate validation (FOC allowed = 0)
        if (isNaN(rate) || rate < 0) hasInvalid = true;

        // ❗ Qty validation
        if (isNaN(qty) || qty < 0) hasInvalid = true;

        // ❗ GST validation
        if ((it.cgst > 0 || it.sgst > 0) && it.igst > 0) {
          hasInvalid = true;
        }

        return {
          id: it.id,
          description,
          approveQty: qty,
          rate,
          cgst: Number(it.cgst || 0),
          sgst: Number(it.sgst || 0),
          igst: Number(it.igst || 0)
        };
      });

      if (hasInvalid) {
        Swal.fire("Error", "Please correct invalid item data", "error");
        return;
      }

      setLoading(true);

      const payload = {
        supplier: formData.supplier,
        items: cleanedItems,
        termCondition: formData.termCondition
      };

      await ReapirPoServices.updatePO(item._id, payload);

      Swal.fire("Updated!", "PO updated successfully.", "success");

      if (test) test(prev => prev + 1);
      handleClose();

    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to update PO", "error");
    } finally {
      setLoading(false);
    }
  };


  const isFOC = item?.poType === "FOC PO";


  return (
    <Modal show={show} onHide={handleClose} size="xl" fullscreen>
      <Modal.Header closeButton>
        <Modal.Title>Edit Purchase Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Delivery Address */}
        <h3 className="text-center">Delivery Address</h3>
        <div className="row mb-3">
          {["street", "city", "state", "pincode", "country"].map((f, idx) => (
            <div className="col-md-4 mb-2" key={idx}>
              <Form.Label>{f.charAt(0).toUpperCase() + f.slice(1)}</Form.Label>
              <Form.Control
                type="text"
                value={formData.deliveryAddress?.[f] || ""}
                placeholder={f}
                readOnly
              />
            </div>
          ))}
        </div>

        {/* Requisition Number & Supplier */}
        <div className="row mb-3">
          <div className="col-md-6 mb-2">
            <Form.Label>Requisition Number</Form.Label>
            <Form.Control type="text" value={formData.requisitionNo || ""} readOnly />
          </div>
          <div className="col-md-6 mb-2">
            <Form.Label>Select Supplier</Form.Label>
            <Form.Select
              className="pb-3 pt-3"
              value={formData.supplier}
              onChange={(e) => setFormData(prev => ({ ...prev, supplier: e.target.value }))}
            >
              <option value="">-- Select Supplier --</option>
              {suppliers.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
            </Form.Select>
          </div>
        </div>
        {/* term and conndition  */}
        <div className="row mb-3">
          <div className="col-md-12 mb-2">
            <Form.Label>Terms & Conditions</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={(formData.termCondition || []).join("\n")}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  termCondition: e.target.value
                    .split("\n")
                    .filter(line => line.trim() !== "")
                }))
              }
            />

          </div>


        </div>

        {/* Items Table */}
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Part No</th>
              <th>Description</th>
              <th>Approved Qty</th>
              <th>Rate</th>
              <th>CGST %</th>
              <th>SGST %</th>
              <th>IGST %</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {formData.items.map((it, idx) => (
              <tr
                key={it.id}
                className={
                  (!it.description || it.description.trim() === "" ||
                    it.rate < 0 ||
                    it.approveQty < 0 ||
                    ((it.cgst > 0 || it.sgst > 0) && it.igst > 0))
                    ? "table-danger"
                    : ""
                }
              >
                <td>{idx + 1}</td>

                <td>{it.partNo}</td>

                {/* ✅ EDITABLE DESCRIPTION */}
                <td>
                  <Form.Control
                    type="text"
                    value={it.description || ""}
                    onChange={(e) => {
                      const newItems = [...formData.items];
                      newItems[idx].description = e.target.value;
                      setFormData(prev => ({ ...prev, items: newItems }));
                    }}
                  />
                </td>

                {/* ✅ EDITABLE QTY */}
                <td>
                  <Form.Control
                    type="number"
                    value={it.approveQty}
                    onChange={(e) =>
                      handleInputChange(idx, "approveQty", e.target.value)
                    }
                  />
                </td>

                {/* ✅ EDITABLE RATE */}
                <td>
                  <Form.Control
                    type="number"
                    value={it.rate}
                    disabled={isFOC}
                    onChange={(e) =>
                      handleInputChange(idx, "rate", e.target.value)
                    }
                  />
                </td>

                {/* CGST */}
                <td>
                  <Form.Control
                    type="number"
                    value={it.cgst}
                    onChange={(e) =>
                      handleInputChange(idx, "cgst", e.target.value)
                    }
                  />
                </td>

                {/* SGST (auto same as CGST) */}
                <td>
                  {it.sgst}
                </td>

                {/* IGST */}
                <td>
                  <Form.Control
                    type="number"
                    value={it.igst}
                    onChange={(e) =>
                      handleInputChange(idx, "igst", e.target.value)
                    }
                  />
                </td>

                {/* AMOUNT */}
                <td>
                  ₹{(
                    (Number(it.rate) || 0) * (Number(it.approveQty) || 0)
                  ).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>


        </table>

        {/* Totals */}
        {formData.items.length > 0 && (
          <div className="mt-3 text-end fw-bold">
            {(() => {
              const t = calculateTotals();
              return (
                <>
                  Base: ₹{t.base} | CGST: ₹{t.cgst} | SGST: ₹{t.sgst} | IGST: ₹{t.igst}
                  <br />
                  <span className="text-primary">Grand Total: ₹{t.total}</span>
                </>
              );
            })()}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Processing...
            </>
          ) : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(POEditModal);
